import React, { createContext, useState } from "react";

const currentMounth = [
  { id: 1, descricao: "Jan" },
  { id: 2, descricao: "Fev" },
  { id: 3, descricao: "Mar" },
  { id: 4, descricao: "Abr" },
  { id: 5, descricao: "Mai" },
  { id: 6, descricao: "Jun" },
  { id: 7, descricao: "Jul" },
  { id: 8, descricao: "Ago" },
  { id: 9, descricao: "Set" },
  { id: 10, descricao: "Out" },
  { id: 11, descricao: "Nov" },
  { id: 12, descricao: "Dez" },
].find(i => i.id === new Date().getMonth() + 1);

const ReportERPContext = createContext();

const ReportERPContextProvider = ({ children }) => {
  const [cnpj, setCnpj] = useState("");
  const [fantasy, setFantasy] = useState("");
  const [base, setBase] = useState("");
  const [typePromoter, setTypePromoter] = useState(null);
  const [year, setYear] = useState({
    descricao: new Date().getFullYear().toString(),
  });
  const [mounth, setMounth] = useState(currentMounth);
  const [valuesTable, setValuesTable] = useState([]);
  const [checkboxes, setCheckboxes] = React.useState({
    Base: true,
    Clientes: true,
    Fornecedores: true,
    Produtos: true,
    Pedidos: true,
    NFe: true,
    NFSe: true,
    BoletoRec: false,
    CCreditoRec: false,
    CDebitoRec: false,
    DinheiroRec: false,
    BoletoPag: false,
    CCreditoPag: false,
    CDebitoPag: false,
    DinheiroPag: false,
  });

  const handleChange = event => {
    setCheckboxes({ ...checkboxes, [event.target.name]: event.target.checked });
  };

  return (
    <ReportERPContext.Provider
      value={{
        cnpj,
        setCnpj,
        fantasy,
        setFantasy,
        base,
        setBase,
        typePromoter,
        setTypePromoter,
        year,
        setYear,
        mounth,
        setMounth,
        checkboxes,
        handleChange,
        valuesTable,
        setValuesTable,
      }}
    >
      {children}
    </ReportERPContext.Provider>
  );
};

export { ReportERPContextProvider, ReportERPContext };
